import { render, staticRenderFns } from "./FaceDetection.vue?vue&type=template&id=7bfb503e&scoped=true"
import script from "./FaceDetection.vue?vue&type=script&lang=js"
export * from "./FaceDetection.vue?vue&type=script&lang=js"
import style0 from "./FaceDetection.vue?vue&type=style&index=0&id=7bfb503e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfb503e",
  null
  
)

export default component.exports